import { TypographyType } from '@platform-ui-kit/components-library/dist/types/components/wpp-typography/types'
import { WppTypography } from '@platform-ui-kit/components-library-react'
import clsx from 'clsx'
import { ReactNode } from 'react'

import { Flex } from 'components/common/flex/Flex'
import { SupportButton } from 'components/intercom/SupportButton'
import styles from 'components/renderError/errorState/base/BaseErrorState.module.scss'

type Props = JSX.IntrinsicElements['div'] & {
  illustration: ReactNode
  mainTitle: string
  subTitle: string
  actions: ReactNode
  description?: string
  mainTitleType?: TypographyType
  showSupportButton?: boolean
}

export const BaseErrorState = ({
  className,
  mainTitle,
  subTitle,
  illustration,
  actions,
  showSupportButton = false,
  mainTitleType = '5xl-display',
  description,
  ...rest
}: Props) => (
  <div {...rest} className={clsx(styles.root, className)} data-testid="error-boundary-state">
    {illustration}

    <div className={styles.textWrapper}>
      <WppTypography type={mainTitleType} data-testid="main-error-title">
        {mainTitle}
      </WppTypography>
      <Flex direction="column" align="center">
        <WppTypography type="m-body" className={styles.subTitle} data-testid="sub-error-title">
          {subTitle}
        </WppTypography>
        {!!description && (
          <WppTypography type="m-body" className={styles.subTitle} data-testid="sub-error-title">
            {description}
          </WppTypography>
        )}
      </Flex>
    </div>

    <Flex justify="center" className={styles.actions}>
      {showSupportButton && <SupportButton />}
      {actions}
    </Flex>
  </div>
)
